import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import TabPanel from "../../../components/TabPanel";

function Tahunan({ value }) {
  const { profil } = useData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getYearlyTransaksiSeller");
      const res = await func({ user_id: profil.id });
      setData(res?.data ?? []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TabPanel value={value} index="tahunan">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip
            formatter={(value) => new Intl.NumberFormat("en").format(value)}
          />
          <Legend />
          <Bar dataKey="total_komisi" fill="#8884d8">
            <LabelList
              dataKey="total_komisi"
              position="inside"
              formatter={(value) => new Intl.NumberFormat("en").format(value)}
            />
          </Bar>
          <Bar dataKey="total_sales" fill="#82ca9d">
            <LabelList
              dataKey="total_sales"
              position="inside"
              formatter={(value) => new Intl.NumberFormat("en").format(value)}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </TabPanel>
  );
}

export default Tahunan;
